import './style.scss';
import Swiper from 'swiper';
import 'swiper/swiper.scss';
export function instagram_block() {
    const block = document.querySelector('.instagram_block');
    if (!block) return;
    document.querySelectorAll('.instagram_block').forEach((block) => {
        const swiper = new Swiper(block.querySelector('.instagram-cards-swiper'), {
            slidesPerView: 1.27,
            loop: true,
            mousewheel: true,
            breakpoints: {
                600: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 4,
                },
            },
        });
    });
}
